import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";
import { BlockStylesConfig, blockStylesInput } from "../common/BlockStylesConfig";
import { TypographyStylesConfig, typographyStylesInput } from "../common/TypographyStylesConfig";


@Form({title: "Box View Config"})
export default class BoxViewConfig {

	@Input({type: InputType.CHECKBOX, title: "Hide Title"})
	public hideTitle?: boolean;

	@Input({type: typographyStylesInput, title: "Box Header Text"})
	public headerTypography?: TypographyStylesConfig;

	@Input({type: blockStylesInput, title: "Box Header Default State"})
	public headerDefaultState?: BlockStylesConfig;

	@Input({type: typographyStylesInput, title: "Box Body Text"})
	public bodyTypography?: TypographyStylesConfig;

	@Input({type: blockStylesInput, title: "Box Body Default State"})
	public bodyDefaultState?: BlockStylesConfig;

}



// WEBPACK FOOTER //
// ./src/common/views/box/BoxConfig.ts